import './category.scss';

import { PropsWithChildren } from "react";

export default function Category(props: PropsWithChildren<unknown>) {
    const id = props.children?.toString().toLowerCase();
    
    return (
        <h1 className='category' id={ id }>{props.children}</h1>
    );
};